// extracted by mini-css-extract-plugin
module.exports = {"avatar":"profile-avatar-module--avatar--1XVRb","icon":"profile-avatar-module--icon--3qOlJ"};